import { RawAxiosRequestConfig } from 'axios';

import Http from '../infrastructure/http';

import type { IService } from '../infrastructure';

class Request extends Http {
  public requestService: <TResData, TReqData = {}>(
    props: IService<TReqData>,
    isAuthNeeded?: boolean,
  ) => Promise<TResData>;

  constructor() {
    super();
    this.requestService = (
      { method = 'GET', relativePath, data, headers, params, responseType },
      isAuthNeeded = true,
    ) => {
      const httpRequest: RawAxiosRequestConfig = {
        data,
        method,
        headers,
        params,
        url: relativePath,
        responseType,
      };
      return this.httpService(httpRequest, isAuthNeeded);
    };
  }
}

const request = new Request();

export default request;
